import React from 'react';
import PropTypes from 'prop-types';
import A11ySvg from 'components/A11ySvg';
import './SubmitIcon.css';

function SubmitIcon({ className, title, alt, filled, disabled }) {
  const setClassName = `submit-icon ${className || ''}${
    filled ? ' filled' : ''
  }${disabled ? ' disabled' : ''}`;
  return (
    <A11ySvg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="500 950 45 45"
      className={setClassName}
      title={title}
      alt={alt}
    >
      <g transform="translate(2 859)">
        <g className="cls-3" transform="matrix(1, 0, 0, 1, -2, -859)">
          <path
            className="cls-1"
            d="M17.53,0A17.53,17.53,0,1,1,0,17.53,17.53,17.53,0,0,1,17.53,0Z"
            transform="translate(504.91 953.94)"
          />
        </g>
        <path
          className="cls-2"
          d="M0,14.114,16.467,7.057,0,0V5.489L11.762,7.057,0,8.625Z"
          transform="translate(513.507 105.545)"
        />
      </g>
    </A11ySvg>
  );
}

SubmitIcon.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  alt: PropTypes.string.isRequired,
  filled: PropTypes.bool,
  disabled: PropTypes.bool
};

export default SubmitIcon;
